import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">MyXmasCard · Custom Holiday Greetings</p>
        <h1>Bring Joy to Your Holidays!</h1>
        <p className="lede">
          Create personalized Christmas cards that capture your family's spirit. Upload your favorite photos and add heartfelt messages to make this holiday season unforgettable.
        </p>
        <div className="cta-row">
          <a href="/create" className="primary">
            Start Designing Your Card
          </a>
          <a href="/gallery" className="secondary">
            Explore Our Gallery
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Easy Customization</h2>
          <p>
            Choose from a variety of templates and personalize them with your own photos and messages to create a unique card that reflects your family's personality.
          </p>
        </article>
        <article>
          <h2>High-Quality Prints</h2>
          <p>
            Our cards are printed on premium cardstock to ensure your holiday greetings look stunning and last a lifetime.
          </p>
        </article>
        <article>
          <h2>Fast Delivery</h2>
          <p>
            Enjoy quick turnaround times so you can send your custom cards out in time for the holidays, spreading cheer to your loved ones.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;